import {
  SKUS,
  PRODUCT_NAMES,
  FIXED_AMOUNTS,
  MATOMO_CUSTOM_DIMENSION_COTTAGE_ID,
} from '../constants'
import { generateOrderId } from '../utils/generateOrderId'
import MatomoService from '../utils/MatomoService'

type BaseParams = {
  province: string
  cottageId: string
}

const buildConversionPayload = ({
  type,
  province,
  cottageId,
  amount,
  orderId,
}: {
  type: keyof typeof SKUS
  province: string
  cottageId: string
  amount: number
  orderId: string
}) => ({
  event: 'matomoEcommerceConversion' as const,
  sku: SKUS[type],
  productName: PRODUCT_NAMES[type],
  orderId,
  amount,
  categories: [province],
  customDimensions: [
    { id: MATOMO_CUSTOM_DIMENSION_COTTAGE_ID, value: cottageId },
  ],
})

export const trackMatomoPhone = ({ province, cottageId }: BaseParams) => {
  MatomoService.send(
    buildConversionPayload({
      type: 'PHONE',
      province,
      cottageId,
      amount: FIXED_AMOUNTS.PHONE,
      orderId: generateOrderId({ type: 'PHONE' }),
    }),
  )
}

export const trackMatomoContact = ({ province, cottageId }: BaseParams) => {
  MatomoService.send(
    buildConversionPayload({
      type: 'CONTACT',
      province,
      cottageId,
      amount: FIXED_AMOUNTS.CONTACT,
      orderId: generateOrderId({ type: 'CONTACT' }),
    }),
  )
}

export const trackMatomoPrebooking = ({
  province,
  cottageId,
  amount,
}: BaseParams & { amount: number }) => {
  MatomoService.send(
    buildConversionPayload({
      type: 'PREBOOKING',
      province,
      cottageId,
      amount: amount / 100,
      orderId: generateOrderId({ type: 'PREBOOKING' }),
    }),
  )
}

export const trackMatomoOnlineBooking = ({
  province,
  cottageId,
  amount,
  bookingId,
}: BaseParams & { amount: number; bookingId: string }) => {
  MatomoService.send(
    buildConversionPayload({
      type: 'ONLINE_BOOKING',
      province,
      cottageId,
      amount: amount / 100,
      orderId: generateOrderId({ type: 'ONLINE_BOOKING', bookingId }),
    }),
  )
}
